import {notRequired, required, requiredZipAndCity} from './rules'

export const requiredFuncMap = {
  givenName: notRequired,
  familyName: notRequired,
  default: required,
  zipCode: requiredZipAndCity,
  city: requiredZipAndCity,
}

// if value is present field becomes required
export function addRequiredValidation(validationFunctions, field, value) {
  if (value) {
    const requiredFunc = requiredFuncMap[field] || requiredFuncMap.default
    validationFunctions.unshift(requiredFunc)
  }

  return validationFunctions
}
